import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress, TextField } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArchiveIcon from '@material-ui/icons/Archive';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
//import { IdentityActions, TermsOfServiceActions, NotificationActions } from '../../../store';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select } from '@material-ui/core';

const style = theme => ({
    root: {
        height: '100%',
    },
    frame: {
        border:'none',
        width: '1200px',
        height: '13000px'
    },
    form: {
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

//const termsOfServicesSelector = (state) => state.TermsOfServices;
//const IdentitySelector = (state) => state.Identity;

const TermsOfServiceDisp = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    //const dispatch = useDispatch();
    //const termsOfServiceActions = bindActionCreators(TermsOfServiceActions, dispatch);
    //const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    //const { list, nowWainting } = useSelector(termsOfServicesSelector);
    //const { token, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    return (
        <Container className={classes.root} maxWidth={false}>
            <div className={classes.form}>
                <Typography component="h1" variant="inherit">{/*<FormattedMessage id="TermsOfService.Title" />*/}</Typography>
            </div>
            <div>
                <iframe src="https://info.okica.jp/kisoku.html" className={classes.frame} scrolling="no" frameborder="no" />
            </div>            
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(TermsOfServiceDisp);
